module.exports = __webpack_public_path__ + "static/media/img_apple_avatar.2e145998.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/GlobalNav/ProfileDropdown/assets/img_apple_avatar.svg
// module id = 1933
// module chunks = 0